export default __webpack_public_path__ + "static/media/00FFE8.0978cf05.svg";